import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { borrowLendHistoryApiConfig } from './borrowLendHistory/constants'
import { fetchApiData as fetchBorrowLendHistoryApiData } from './borrowLendHistory/fetchApiData'
import { capitalHistoryApiConfig } from './capitalHistory/constants'
import { fetchApiData as fetchCapitalHistoryApiData } from './capitalHistory/fetchApiData'
import { fillHistoryApiConfig } from './fillHistory/constants'
import { fetchApiData as fetchFillHistoryApiData } from './fillHistory/fetchApiData'
import { fundingHistoryApiConfig } from './fundingHistory/constants'
import { fetchApiData as fetchFundingHistoryApiData } from './fundingHistory/fetchApiData'
import { getCurrentBackpackAssets } from './getCurrentAsset'
import { interestHistoryApiConfig } from './interestHistory/constants'
import { fetchApiData as fetchInterestHistoryApiData } from './interestHistory/fetchApiData'
import { realizedPnlHistoryApiConfig } from './realizedPnlHistory/constants'
import { fetchApiData as fetchRealizedPnlHistoryApiData } from './realizedPnlHistory/fetchApiData'

export const backpackApiConfigs = {
  [borrowLendHistoryApiConfig.type]: borrowLendHistoryApiConfig,
  [capitalHistoryApiConfig.type]: capitalHistoryApiConfig,
  [fillHistoryApiConfig.type]: fillHistoryApiConfig,
  [fundingHistoryApiConfig.type]: fundingHistoryApiConfig,
  [interestHistoryApiConfig.type]: interestHistoryApiConfig,
  [realizedPnlHistoryApiConfig.type]: realizedPnlHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type BackpackApiType = keyof typeof backpackApiConfigs

export const backpackApiTypes = Object.keys(
  backpackApiConfigs,
) as BackpackApiType[]

export const fetchBackpackApiDataFuncs = {
  [borrowLendHistoryApiConfig.type]: fetchBorrowLendHistoryApiData,
  [capitalHistoryApiConfig.type]: fetchCapitalHistoryApiData,
  [fillHistoryApiConfig.type]: fetchFillHistoryApiData,
  [fundingHistoryApiConfig.type]: fetchFundingHistoryApiData,
  [interestHistoryApiConfig.type]: fetchInterestHistoryApiData,
  [realizedPnlHistoryApiConfig.type]: fetchRealizedPnlHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchBackpackSubTypesFuncs = {
  [borrowLendHistoryApiConfig.type]: undefined,
  [capitalHistoryApiConfig.type]: undefined,
  [fillHistoryApiConfig.type]: undefined,
  [fundingHistoryApiConfig.type]: undefined,
  [interestHistoryApiConfig.type]: undefined,
  [realizedPnlHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentBackpackAssets }
